import { AddonProduct } from 'models/AddonProduct';
import { BasePageModel } from 'models/BasePageModel';
import { PageState } from 'models/PageState';
import { isProductPage } from 'models/ProductPageModel';
import { getAllSelectedProducts } from './utils';

export const selectAddonServices = (state: PageState) => {
  return isProductPage(state.currentPage)
    ? state.currentPage.addonServices?.addonServiceProducts
    : [];
};

export const selectAddonServicesZipCode = (state: PageState) => {
  if (isProductPage(state.currentPage)) {
    const zipCode = state.currentPage.addonServices?.addonServicesZipCode;
    return zipCode ? zipCode : '';
  }
  return '';
};

export const hasSelectedAddonService = (state: PageState) => {
  return isProductPage(state.currentPage) && state.currentPage.addonServices?.addonServiceProducts
    ? state.currentPage.addonServices?.addonServiceProducts.some(p => p.selected)
    : false;
};

export const getSelectedAddonServices = (currentPage: BasePageModel): AddonProduct[] => {
  if (!isProductPage(currentPage) || currentPage.addonServices === undefined) {
    return [];
  }

  return getAllSelectedProducts(currentPage.addonServices.addonServiceProducts);
};
